import { getMips } from './backendHelper'

export function fetchMips(data, stringValue = true) {
  return getMips(data)
    .then((res) => {
      if (res) {
        // the code requires the option data to properly format saved, attested MIPS
        // stringValue lets us either return the full value object (for encounters) or the string value only (for notes)
        let fusionMIPS = res?.map((item) => ({
          ...item,
          value: stringValue ? item.value?.label || item.value : item?.option_data,
          // keeps MIPS object smaller
          rules: undefined,
        }))
        return sortMipsByNumber(fusionMIPS)
      } else {
        console.error('Failed to load MIPS')
        return []
      }
    })
    .catch((e) => {
      console.error('Error loading MIPS', e)
      return []
    })
}

function sortMipsByNumber(mips) {
  return mips.sort((a, b) => {
    let qualityA = a.qualityId.trim()
    let qualityB = b.qualityId.trim()
    let measureKeyA = a.measureKey.trim().slice(-1)
    let measureKeyB = b.measureKey.trim().slice(-1)
    return (
      // subtract qualityIds
      parseInt(qualityA, 10) - parseInt(qualityB, 10) ||
      // unless they are same, use last number of key (since above will resolve to 0 if same)
      parseInt(measureKeyA, 10) - parseInt(measureKeyB, 10)
    )
  })
}

export function getQualityMips(visitId, practiceId) {
  return fetchMips(
    {
      charge_id: visitId,
      practice_id: practiceId,
    },
    false,
  )
    .then((res) => {
      return res || []
    })
    .catch((e) => {
      console.error(e)
      return []
    })
}
